import React from "react";
import PolicyLayout from "@/components/PolicyLayout";
export default function PrivacyPolicy() {
  return <PolicyLayout ns="privacy" />;
}
